import * as React from 'react'
import { useContext } from 'react'
import styled from 'styled-components'
import { TabsContext } from './Tabs'

export interface TabContentItemProps {
  children: React.ReactNode
  tabId: string
}

const TabContentWrapper = styled.div<{
  active?: boolean
}>`
  left: 0;
  margin: auto;
  opacity: ${({ active }) => (active ? 1 : 0)};
  position: absolute;
  top: 0;
  transition: opacity 0.35s ease-in-out, visibility 0.35s ease-in-out;
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  width: 100%;
  z-index: ${({ active }) => (active ? 1 : 0)};
`

export const TabContentItem = ({ children, tabId }: TabContentItemProps) => {
  const { activeTabId } = useContext(TabsContext)

  return <TabContentWrapper active={activeTabId === tabId}>{children}</TabContentWrapper>
}
